import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAuthorizationHeader, http } from '../../config/http';
import LayoutsKasir from '../../layouts/LayoutsKasir';
import { DinamicTitle } from '../../utils/DinamicTitle';
import RfPembelian from './DetailPengembalian/RfPembelian';
import RfPenjualan from './DetailPengembalian/RfPenjualan';
import { useRefundAccess } from '../../hooks/useRefundAccess';

const PengembalianBarang = () => {
  DinamicTitle('Pengembalian || Komaladewi');
  const navigate = useNavigate();
  const { isRefundAllowed, currentCabangName, currentCabangId, role } = useRefundAccess();
  const [scanKode, setScanKode] = useState('');

  const [detailBarangPembelian, setDetailBarangPembelian] = useState([]);
  const [detailBarangPenjualan, setDetailBarangPenjualan] = useState([]);

  let [modalPembelian, setOpenModalPembelian] = useState(false);
  let [modalPenjualan, setOpenModalPenjualan] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loadingRf, setLodaingRf] = useState(false);
  const [checkKode, setCheckKode] = useState('');

  // MODAL PENJUALAN
  function closeModalPenjualan() {
    setOpenModalPenjualan(false);
    window.location.reload();
  }

  function openModalPenjualan() {
    setOpenModalPenjualan(true);
  }
  // MODAL PEMBELIAN

  function closeModalPembelian() {
    setOpenModalPembelian(false);
    window.location.reload();
  }

  function openModalPembelian() {
    setOpenModalPembelian(true);
  }

  async function refundBarang(keteranganRefund, karyawanId) {
    setLodaingRf(true);
    const targetKode = checkKode || scanKode;
    await http
      .put(
        `penjualan/refund/${targetKode}`,
        {
          keterangan_refund: keteranganRefund,
          karyawan_id: karyawanId,
        },
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      )
      .then((res) => {
        toast.success(res.data?.message || 'Berhasil memproses refund!', { autoClose: 1000 });
        setScanKode('');
        setTimeout(() => {
          window.location.reload();
        }, 800);
      })
      .catch((err) => {
        const errorData = err.response?.data;
        if (errorData?.errors) {
          const firstErrKey = Object.keys(errorData.errors)[0];
          const firstErrMsg = errorData.errors[firstErrKey][0];
          toast.error(firstErrMsg, { autoClose: 2500 });
        } else if (errorData?.message) {
          toast.error(errorData.message, { autoClose: 2500 });
        } else if (err.response?.status === 403) {
          toast.error('Silahkan segarkan halaman atau login kembali', { autoClose: 2000 });
        } else {
          toast.error('Terjadi kesalahan saat memproses refund', { autoClose: 2000 });
        }
      });
    setLodaingRf(false);
  }

  async function handleScanBarangRefund() {
    setLoading(true);
    await http.get(`penjualan/scan/${scanKode}?context=refund`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        const data = res.data?.data;
        if (!data) return;

        // Validasi kecocokan cabang transaksi dengan toko kasir login (kecuali owner/admin)
        const isSuperUser = role === 'owner' || role === 'admin';
        const trxCabangId = data?.user?.cabang_id || data?.cabang_id || data?.item?.cabang_id;
        const namaCabangTrx = data?.user?.cabang?.nama_cabang || data?.cabang?.nama_cabang || data?.item?.cabang?.nama_cabang || 'toko lain';

        if (!isSuperUser && currentCabangId && trxCabangId && String(currentCabangId) !== String(trxCabangId)) {
          toast.error(`Barang / transaksi ini berasal dari ${namaCabangTrx}. Pengembalian (return / refund) hanya dapat dilakukan di toko asal transaksi!`, {
            autoClose: 3500,
          });
          setScanKode('');
          return;
        }

        if (data?.kode_trx?.substring(0, 4) === 'FKDB') {
          setDetailBarangPembelian(data);
          openModalPembelian();
        } else if (data?.kode_trx?.substring(0, 4) === 'FKDJ') {
          setDetailBarangPenjualan(data);
          openModalPenjualan();
        }
        setCheckKode(data.kode_trx);
      })
      .catch((err) => {
        const errorData = err.response?.data;
        if (errorData?.message) {
          toast.error(errorData.message, { autoClose: 3000 });
        } else if (err.response?.status === 403) {
          toast.error('Silahkan segarkan halaman atau login kembali', { autoClose: 2000 });
        } else {
          toast.error('Gagal memindai transaksi. Silahkan coba lagi.', { autoClose: 2000 });
        }
        setScanKode('');
      });
    setLoading(false);
  }

  useEffect(() => {
    if (!isRefundAllowed) return;
    if (scanKode && scanKode.length >= 10) {
      handleScanBarangRefund();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scanKode, isRefundAllowed]);

  useEffect(() => {
    if (!isRefundAllowed) return;
    const handleKeyDown = (e) => {
      if (e.key?.toLocaleLowerCase() === 'i' && e.ctrlKey) {
        document.getElementById('MySearch')?.focus();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isRefundAllowed]);

  if (!isRefundAllowed) {
    return (
      <LayoutsKasir>
        <div className="w-full max-w-lg mx-auto my-12 p-8 bg-white dark:bg-slate-900 rounded-3xl border border-rose-200 dark:border-rose-900/40 shadow-xl text-center space-y-4 animate-in fade-in zoom-in-95 duration-200">
          <div className="w-16 h-16 rounded-2xl bg-rose-100 dark:bg-rose-950/60 text-rose-600 dark:text-rose-400 mx-auto flex items-center justify-center shadow-xs">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100">
            Akses Pengembalian Dibatasi
          </h2>
          <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
            Toko/cabang <strong className="text-slate-800 dark:text-slate-100">{currentCabangName || (currentCabangId ? `ID: ${currentCabangId}` : 'saat ini')}</strong> tidak memiliki izin akses untuk menu Pengembalian / Refund barang.
          </p>
          <p className="text-xs text-slate-500 dark:text-slate-400">
            Silakan hubungi Owner atau Administrator untuk mengaktifkan izin toko ini melalui menu <strong>Pengaturan Sistem</strong>.
          </p>
          <div className="pt-2 flex justify-center gap-3">
            <button
              onClick={() => navigate('/')}
              className="px-5 py-2.5 rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-semibold text-sm transition shadow-sm active:scale-95 cursor-pointer"
            >
              Kembali ke Beranda
            </button>
          </div>
        </div>
      </LayoutsKasir>
    );
  }

  return (
    <LayoutsKasir>
      <div className="w-full max-w-4xl mx-auto py-2">
        <div className="relative flex items-center">
          <div className="absolute left-3.5 z-10 w-10 h-10 rounded-xl bg-amber-500 text-white flex items-center justify-center shadow-sm">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
          <input
            type="text"
            id="MySearch"
            value={scanKode}
            onChange={(e) => setScanKode(e.target.value)}
            className="w-full h-14 pl-16 pr-24 text-base sm:text-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-[#152037] text-slate-800 dark:text-slate-100 rounded-2xl shadow-sm focus:outline-none focus:ring-2 focus:ring-amber-500/40 focus:border-amber-500 placeholder:text-slate-400 dark:placeholder:text-slate-500 transition-all"
            placeholder="Masukkan KODE FAKTUR ...."
          />
          <div className="absolute right-4 hidden sm:flex items-center px-2 py-1 bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-xs font-semibold text-slate-500 dark:text-slate-400 pointer-events-none">
            CTRL + I
          </div>
        </div>
      </div>
      <div>
        {loading ? (
          <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20 opacity-75 flex flex-col items-center justify-center">
            <div className="w-12 h-12  rounded-full animate-spin border-4 border-dashed border-green-500 border-t-transparent"></div>
          </div>
        ) : (
          <>
            {checkKode.substring(0, 4) === 'FKDB' ? (
              <RfPembelian
                detailBarangPembelian={detailBarangPembelian}
                refundBarang={refundBarang}
                loadingRf={loadingRf}
                modalPembelian={modalPembelian}
                closeModalPembelian={closeModalPembelian}
              />
            ) : checkKode.substring(0, 4) === 'FKDJ' ? (
              <RfPenjualan
                modalPenjualan={modalPenjualan}
                closeModalPenjualan={closeModalPenjualan}
                loadingRf={loadingRf}
                refundBarang={refundBarang}
                detailBarangPenjualan={detailBarangPenjualan}
              />
            ) : (
              ''
            )}
          </>
        )}
      </div>
    </LayoutsKasir>
  );
};

export default PengembalianBarang;
